function RouteLoadingFallback({ fullViewport = false }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        alignItems: 'center',
        color: 'var(--color-monotone-4, #666)',
        display: 'flex',
        justifyContent: 'center',
        minHeight: fullViewport ? '100vh' : '240px',
        width: '100%',
      }}
    >
      화면을 불러오는 중입니다.
    </div>
  );
}

export default RouteLoadingFallback;
